module.exports = "<svg viewBox=\"0 0 11 8\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M9.50419 0.170854C9.73199 -0.0569515 10.1012 -0.0569513 10.3291 0.170854C10.5569 0.39866 10.5569 0.767918 10.3291 0.995724L3.91239 7.41239C3.68459 7.6402 3.31533 7.6402 3.08752 7.41239L0.170854 4.49572C-0.0569515 4.26792 -0.0569515 3.89866 0.170854 3.67085C0.39866 3.44305 0.767918 3.44305 0.995724 3.67085L3.49996 6.17509L9.50419 0.170854Z\"/>\n</svg>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./static/icons/buttons/check.svg
// module id = nFlk
// module chunks = 0